import { configureStore, combineReducers, AnyAction } from '@reduxjs/toolkit';

import AccountDeviceReducer from './slices/AccountDeviceSlice';
import accountLevelReducer from './slices/AccountLevelSlice';
import AccountLocationReducer from './slices/AccountLocationSlice';
import AccountManagementReducer from './slices/AccountManagementSlice';
import AccountPayoutDeviceReducer from './slices/AccountPayoutDeviceSlice';
import AccountPayoutTransactionReducer from './slices/AccountPayoutTransactionSlice';
import RevenueSharingReducer from './slices/AccountRevenueSharing';
import AlertsReducer from './slices/AlertsSlice';
import ApprovedElectricityPriceReducer from './slices/ApprovedElectricityPriceSlice';
import ApprovedLocationManagementReducer from './slices/ApprovedLocationManagementSlice';
import ApprovedPricingReducer from './slices/ApprovedPricingSlice';
import ApprovedStripePayoutsReducer from './slices/ApprovedStripePayoutsSlice';
import BrandReducer from './slices/BrandSlice';
import RevenueByMonthReducer from './slices/ByMonthRevenueSlice';
import ByTransactionReducer from './slices/ByTransactionSlice';
import CampaignReducer from './slices/CampaignManagementSlice';
import CardGroupReducer from './slices/CardGroupSlice';
import ChargerStatusReducer from './slices/ChargerTypeSlice';
import ChargingPointReducer from './slices/ChargingPointSlice';
import ChargingScheduleReducer from './slices/ChargingScheduleSlice';
import ChargingSessionSlice from './slices/ChargingSessionSlice';
import ConnectorRatingReducer from './slices/ConnectorRatingSlice';
import ConnectorReducer from './slices/ConnectorSlice';
import CustomDashboardReducer from './slices/CustomDashboardSlice';
import CustomTariffReducer from './slices/CustomTariffSlice';
import DeviceAlertsReducer from './slices/DeviceAlertsSlice';
import DeviceBlockedWebsocketReducer from './slices/DeviceBlockedWebsocketSlice';
import DeviceDetailsChargingSessionSlice from './slices/DeviceDetailsChargingSessionSlice';
import DeviceErrorLogsReducer from './slices/DeviceErrorLogs';
import DeviceHubReducer from './slices/DeviceHubSlice';
import DeviceManagementReducer from './slices/DeviceManagementSlice';
import DeviceNeverBlockedWebsocketReducer from './slices/DeviceNeverBlockedWebsocketSlice';
import OcppLogsReducer from './slices/DeviceOcppLogsSilce';
import DeviceTransactionReducer from './slices/DeviceTransactionSlice';
import DiagnosticFirmwareReducer from './slices/DiagnosticFirmwareSlice';
import EMSPCommercialSessionReducer from './slices/EMSPCommercialSessionSlice';
import EMSPCommercialTransactionReducer from './slices/EMSPCommercialTransactionSlice';
import EMSPersonalTransactionReducer from './slices/EMSPPersonalSessionSlice';
import EMSPPreauthReducer from './slices/EMSPPreauthSlice';
import ConsumerChargeCommercialReducer from './slices/EndConsumerChargeCommercial';
import ConsumerChargePersonalReducer from './slices/EndConsumerChargePersonal';
import EndConsumerManagementReducer from './slices/EndConsumerManagementSlice';
import ConsumerPaymentHistoryReducer from './slices/EndConsumerPaymentHistory';
import EndConsumerPersonalChargerReducer from './slices/EndConsumerPersonalChargerSlice';
import ConsumerReservationsReducer from './slices/EndConsumerReservations';
import ConsumerScheduleCompletedReducer from './slices/EndConsumerScheduleCompleted';
import ConsumerScheduleUpcomingReducer from './slices/EndConsumerScheduleUpcoming';
import EndConsumerReducer from './slices/EndConsumerSlice';
import ConsumerTransactionHistoryReducer from './slices/EndConsumerTransactionHistory';
import ConsumerGuestChargingReducer from './slices/EnsConsumerGuestCharging';
import FacilitySidePanelReducer from './slices/FacilitySidePanelSlice';
import FileUploadStreamReducer from './slices/FileUploadStreamSlice';
import FirmwareJobsReducer from './slices/FirmwareJobsSlice';
import FirmwareVersionReducer from './slices/FirmwareVersionSlice';
import GlobalBrandReducer from './slices/GlobalBrandSlice';
import GlobalConnectorReducer from './slices/GlobalConnectorSlice';
import GlobalModelReducer from './slices/GlobalModelSlice';
import GuestChargingLocationReducer from './slices/GuestChargingLocationSlice';
import GuestChargingReducer from './slices/GuestChargingSlice';
import HealthFaultAnalyticsReducer from './slices/HealthFaultAnalyticsReportSlice';
import HistoricalFaultReducer from './slices/HistoricalFaultSlice';
import InvoiceReducer from './slices/InvoiceSlice';
import LayoutReducer from './slices/LayoutSlice';
import LocationActivityReducer from './slices/LocationActivitySlice';
import LocationComparisonSlice from './slices/LocationComparisonSlice';
import LocationDashboardDeviceReducer from './slices/LocationDashboardDeviceSlice';
import LocationDetailsChargingSessionSlice from './slices/LocationDetailsChargingSessionSlice';
import LocationDetailsReducer from './slices/LocationDetailsSlice';
import LocationManagementReducer from './slices/LocationManagementSidePanelSlice';
import LocationPerformanceReducer from './slices/LocationPerformanceSlice';
import LocationRevenueSharingReducer from './slices/LocationRevenueSharingSlice';
import MaintenanceScheduleManagementReducer from './slices/MaintenanceScheduleManagementSlice';
import MaintenanceScheduleReducer from './slices/MaintenanceScheduleSlice';
import ModelReducer from './slices/ModelSlice';
import NotificationMessageReducer from './slices/NotificationManagementSlice';
import CPOCdrsReducer from './slices/OCPI/CPOCdrsSlice';
import CPOCommandsReducer from './slices/OCPI/CPOCommandsSlice';
import CPOConnectionLogReducer from './slices/OCPI/CPOConnectionLogsSlice';
import CPOLocationsReducer from './slices/OCPI/CPOLocationsSlice';
import CPOSessionsReducer from './slices/OCPI/CPOSessionsSlice';
import CPOTariffsReducer from './slices/OCPI/CPOTariffsSlice';
import CPOTokensReducer from './slices/OCPI/CPOTokensSlice';
import EMSPCdrsReducer from './slices/OCPI/EMSPCdrsSlice';
import EMSPCommandsReducer from './slices/OCPI/EMSPCommandsSlice';
import EMSPConnectionLogReducer from './slices/OCPI/EMSPConnectionLogsSlice';
import EMSPLocationsReducer from './slices/OCPI/EMSPLocationsSlice';
import EMSPSessionsReducer from './slices/OCPI/EMSPSessionsSlice';
import EMSPTariffsReducer from './slices/OCPI/EMSPTariffsSlice';
import EMSPTokensReducer from './slices/OCPI/EMSPTokensSlice';
import OcpiConnectionsReducer from './slices/OCPI/OCPIConnectionsSlice';
import OcpiVersionsReducer from './slices/OCPI/OCPIVersionsSlice';
import OcppCPOLogReducer from './slices/OcppLogSlice';
import OcppMessageReducer from './slices/OcppMessageSlice';
import OcppMessageReducerV2 from './slices/OcppMessageSlicev2';
import PageTitleReducer from './slices/PageTitleSlice';
import PartnersApprovedLocationManagementReducer from './slices/Partners/ApprovedLocationManagementSlice';
import PartnersDevice from './slices/Partners/DeviceManagementSlice';
import PartnersFacilityTagReducer from './slices/Partners/FacilityTagSlice';
import PartnersGuestChargingLocationReducer from './slices/Partners/GuestChargingLocationSlice';
import ParstnersGuestChargingReducer from './slices/Partners/GuestChargingSlice';
import PartnersPendingLocationManagementReducer from './slices/Partners/PendingLocationManagementSlice';
import PartnersRejectLocationManagementReducer from './slices/Partners/RejectedLocationManagementSlice';
import ScheduleManagementReducer from './slices/Partners/ScheduleManagementSlice';
import TransactionReducer from './slices/Partners/TransactionManagementSlice';
import UserManagementPartnerReducer from './slices/Partners/UserManagementSlice';
import PartnerTariffReducer from './slices/PartnerTariffSlice';
import PaymentGatewayReducer from './slices/PaymentGatewaySlice';
import PaymentManagementReducer from './slices/PaymentManagementSlice';
import PaymentTransactionReducer from './slices/PaymentTransactionSlice';
import PayoutReducer from './slices/PayoutSlice';
import PenaltyAccountListReducer from './slices/PenaltyAccountListSlice';
import PenaltyLocationListReducer from './slices/PenaltyLocationListSlice';
import transactionListPenaltyReducer from './slices/PenaltyTransactionSlice';
import PendingPricingReducer from './slices/PendingPricingSlice';
import PersonalChargingSessionSlice from './slices/PersonalChargingSessionSlice';
import PersonalDeviceReducer from './slices/PersonalDeviceSlice';
import PowerBankPreauthReducer from './slices/PowerBankPreauthSlice';
import ProductReducer from './slices/ProductSlice';
import RejectedElectricityPriceReducer from './slices/RejectedElectricityPriceSlice';
import RejectedLocationManagementReducer from './slices/RejectedLocationManagementSlice';
import RejectedPricingReducer from './slices/RejectedPricingSlice';
import RejectedStripePayoutsReducer from './slices/RejectedStripePayoutsSlice';
import ReportAlertsLocationReducer from './slices/ReportAlertsLocationSlice';
import ReportAlertsPointReducer from './slices/ReportAlertsPointSlice';
import ReportBookingLocationReducer from './slices/ReportBookingLocationSlice';
import ReportBookingPointReducer from './slices/ReportBookingPointSlice';
import ReportsChargerUtilizationLocationReducer from './slices/ReportChargerLocationSlice';
import ReportsChargerUtilizationPointReducer from './slices/ReportChargerPointSlice';
import ReportEnergyLocationReducer from './slices/ReportEnergyLocationSlice';
import ReportEnergyPointReducer from './slices/ReportEnergyPointSlice';
import ReportMaintenanceLocationReducer from './slices/ReportMaintenanceLocationSlice';
import ReportMaintenancePointReducer from './slices/ReportMaintenancePointSlice';
import ReportManagementReducer from './slices/ReportManagementSlice';
import ReportPerformanceLocationReducer from './slices/ReportPerformanceLocationSlice';
import ReportPerformancePointReducer from './slices/ReportPerformancePointSlice';
import ReportRevenueLocationReducer from './slices/ReportRevenueLocationSlice';
import ReportRevenuePointReducer from './slices/ReportRevenuePointSlice';
import ReportReducer from './slices/ReportSlice';
import RequestApprovedAccountReducer from './slices/RequestApprovedAccountSlice';
import RequestApprovedLocationReducer from './slices/RequestApprovedLocationSlice';
import RequestPendingAccountReducer from './slices/RequestPendingAccountSlice';
import RequestPendingLocationReducer from './slices/RequestPendingLocationSlice';
import RequestRejectedAccountReducer from './slices/RequestRejectedAccountSlice';
import RequestRejectedLocationReducer from './slices/RequestRejectedLocationSlice';
import RevenueManagementAccountReducer from './slices/RevenueManagementAccountSlice';
import RevenueManagementLocationReducer from './slices/RevenueManagementLocationSlice';
import RfidCardsReducer from './slices/RfidManagementSlice';
import RfidTokensReducer from './slices/RfidTokenSlice';
import RoleManagementReducer from './slices/RolesManagementSlice';
import softWareLogsReducer from './slices/SoftWareLogsSlice';
import SummaryReportsReducer from './slices/SummaryReportSlice';
import TableModalReducer from './slices/TableModalSlice';
import TableSidePanelReducer from './slices/TableSidePanelSlice';
import TableTextSizeReducer from './slices/TableTextSizeSlice';
import TapCardLedgerReducer from './slices/TapCardLedgerSlice';
import TariffReducer from './slices/TariffSlice';
import TransactionLocationReducer from './slices/TransactionsLocationSlice';
import UnapprovedElectricityPriceReducer from './slices/UnapprovedElectricityPriceSlice';
import UnapprovedLocationManagementReducer from './slices/UnapprovedLocationManagementSlice';
import UnapprovedStripePayoutsReducer from './slices/UnapprovedStripePayoutsSlice';
import UpcomingMaintenancesReducer from './slices/UpcomingMaintenanceSlice';
import UpTimeReducer from './slices/UpTimeListAndChartSlice';
import UserManagementReducer from './slices/UsersManagementSlice';
import UtilityManagementReducer from './slices/UtilityProviderManagementSlice';
import UtilizationEfficiencyReportReducer from './slices/UtilizationEfficiencyReportSlice';
import VlbcReducer from './slices/VlbcSlice';

// Store configure with the reducer
const appReducer = combineReducers({
  accounts: AccountManagementReducer,
  utility: UtilityManagementReducer,
  customDashboard: CustomDashboardReducer,
  endConsumer: EndConsumerManagementReducer,
  notification: NotificationMessageReducer,
  payments: PaymentManagementReducer,
  paymentGateway: PaymentGatewayReducer,
  paymentTransactions: PaymentTransactionReducer,
  chargingSession: ChargingSessionSlice,
  deviceDetailsChargingSession: DeviceDetailsChargingSessionSlice,
  locationDetailsChargingSession: LocationDetailsChargingSessionSlice,
  connectorRating: ConnectorRatingReducer,
  connector: ConnectorReducer,
  globalConnector: GlobalConnectorReducer,
  personalChargingSession: PersonalChargingSessionSlice,
  users: UserManagementReducer,
  partnerUsers: UserManagementPartnerReducer,
  roles: RoleManagementReducer,
  layout: LayoutReducer,
  approvedLocation: ApprovedLocationManagementReducer,
  unapprovedLocation: UnapprovedLocationManagementReducer,
  rejectedLocation: RejectedLocationManagementReducer,
  reports: ReportManagementReducer,
  approvedPricing: ApprovedPricingReducer,
  pendingPricing: PendingPricingReducer,
  rejectedPricing: RejectedPricingReducer,
  revenueAccount: RevenueManagementAccountReducer,
  revenueLocation: RevenueManagementLocationReducer,
  revenueSharing: RevenueSharingReducer,
  locationRevenueSharing: LocationRevenueSharingReducer,
  ocppMessage: OcppMessageReducer,
  ocppMessageV2: OcppMessageReducerV2,
  chargingPoint: ChargingPointReducer,
  device: DeviceManagementReducer,
  deviceHub: DeviceHubReducer,
  brand: BrandReducer,
  globalBrand: GlobalBrandReducer,
  personalDevice: PersonalDeviceReducer,
  chargingSchedule: ChargingScheduleReducer,
  guestCharging: GuestChargingReducer,
  deviceTransaction: DeviceTransactionReducer,
  diagnosticFirmware: DiagnosticFirmwareReducer,
  firmwareJobs: FirmwareJobsReducer,
  model: ModelReducer,
  globalModel: GlobalModelReducer,
  firmwareVersion: FirmwareVersionReducer,
  maintenanceSchedule: MaintenanceScheduleReducer,
  campaign: CampaignReducer,
  deviceAlert: DeviceAlertsReducer,
  rfidCard: RfidCardsReducer,
  rfidTokens: RfidTokensReducer,
  cardGroups: CardGroupReducer,
  tapCardLedger: TapCardLedgerReducer,
  ocppLogs: OcppLogsReducer,
  approvedElectricityPrice: ApprovedElectricityPriceReducer,
  unapprovedElectricityPrice: UnapprovedElectricityPriceReducer,
  rejectedElectricityPrice: RejectedElectricityPriceReducer,
  stripePayouts: ApprovedStripePayoutsReducer,
  unapprovedStripePayouts: UnapprovedStripePayoutsReducer,
  rejectedStripePayouts: RejectedStripePayoutsReducer,
  reportData: ReportReducer,
  reportEnergyLocation: ReportEnergyLocationReducer,
  reportEnergyPoint: ReportEnergyPointReducer,
  reportRevenuePoint: ReportRevenuePointReducer,
  reportRevenueLocation: ReportRevenueLocationReducer,
  reportBookingLocation: ReportBookingLocationReducer,
  reportBookingPoint: ReportBookingPointReducer,
  reportChargerPoint: ReportsChargerUtilizationPointReducer,
  reportChargerLocation: ReportsChargerUtilizationLocationReducer,
  reportPerformanceLocation: ReportPerformanceLocationReducer,
  reportPerformancePoint: ReportPerformancePointReducer,
  reportMaintenancePoint: ReportMaintenancePointReducer,
  reportMaintenanceLocation: ReportMaintenanceLocationReducer,
  reportAlertsPoint: ReportAlertsPointReducer,
  reportAlertsLocation: ReportAlertsLocationReducer,
  tableSidePanel: TableSidePanelReducer,
  deviceBlocked: DeviceBlockedWebsocketReducer,
  deviceNeverBlocked: DeviceNeverBlockedWebsocketReducer,
  chargerStatus: ChargerStatusReducer,
  deviceErrorLogs: DeviceErrorLogsReducer,
  byTransaction: ByTransactionReducer,
  revenueByMonth: RevenueByMonthReducer,
  accountLocation: AccountLocationReducer,
  accountDevice: AccountDeviceReducer,
  accountPayoutDevice: AccountPayoutDeviceReducer,
  accountPayoutTransaction: AccountPayoutTransactionReducer,
  payout: PayoutReducer,
  accountLevel: accountLevelReducer,
  tableTextSize: TableTextSizeReducer,
  accountPenalty: PenaltyAccountListReducer,
  locationPenalty: PenaltyLocationListReducer,
  transactionPenalty: transactionListPenaltyReducer,
  requestApprovedAccount: RequestApprovedAccountReducer,
  requestApprovedLocation: RequestApprovedLocationReducer,
  requestPendingAccount: RequestPendingAccountReducer,
  requestPendingLocation: RequestPendingLocationReducer,
  requestRejectedAccount: RequestRejectedAccountReducer,
  requestRejectedLocation: RequestRejectedLocationReducer,
  locationActivity: LocationActivityReducer,
  locationDashboardDevice: LocationDashboardDeviceReducer,
  alertsLocation: AlertsReducer,
  softWareLogs: softWareLogsReducer,
  HistoricalFault: HistoricalFaultReducer,
  SummaryReports: SummaryReportsReducer,
  UtilizationEfficiencyReport: UtilizationEfficiencyReportReducer,
  HealthFaultAnalyticsReport: HealthFaultAnalyticsReducer,
  transactions: TransactionLocationReducer,
  guestChargingLocation: GuestChargingLocationReducer,
  upcomingMaintenances: UpcomingMaintenancesReducer,
  locationManagement: LocationManagementReducer,
  locationDetails: LocationDetailsReducer,
  locationPerformance: LocationPerformanceReducer,
  locationComparison: LocationComparisonSlice,
  UpTime: UpTimeReducer,
  pageTitle: PageTitleReducer,
  tableModal: TableModalReducer,
  ConsumerChargeCommercial: ConsumerChargeCommercialReducer,
  ConsumerChargePersonal: ConsumerChargePersonalReducer,
  ConsumerGuestCharging: ConsumerGuestChargingReducer,
  ConsumerReservations: ConsumerReservationsReducer,
  ConsumerScheduleCompleted: ConsumerScheduleCompletedReducer,
  ConsumerScheduleUpcoming: ConsumerScheduleUpcomingReducer,
  ConsumerTransactionHistory: ConsumerTransactionHistoryReducer,
  ConsumerPaymentHistory: ConsumerPaymentHistoryReducer,
  ConsumerPersonalCharger: EndConsumerPersonalChargerReducer,
  endConsumerType: EndConsumerReducer,
  facilitySidePanel: FacilitySidePanelReducer,
  tariff: TariffReducer,
  customTariff: CustomTariffReducer,
  partnerTariff: PartnerTariffReducer,
  vlbc: VlbcReducer,
  partnersApprovedLocation: PartnersApprovedLocationManagementReducer,
  partnersDevice: PartnersDevice,
  partnersMaintenanceSchedule: MaintenanceScheduleManagementReducer,
  fileUpload: FileUploadStreamReducer,
  schedules: ScheduleManagementReducer,
  partnersTransaction: TransactionReducer,
  partnersFacilityTags: PartnersFacilityTagReducer,
  partnersRejectLocation: PartnersRejectLocationManagementReducer,
  partnersPendingLocation: PartnersPendingLocationManagementReducer,
  partnerGuestChargingLocation: PartnersGuestChargingLocationReducer,
  partnerGuestCharging: ParstnersGuestChargingReducer,
  emspPersonalTransaction: EMSPersonalTransactionReducer,
  emspCommercialTransaction: EMSPCommercialTransactionReducer,
  emspPreauth: EMSPPreauthReducer,
  powerBankPreauth: PowerBankPreauthReducer,
  product: ProductReducer,
  ocppCPOLogs: OcppCPOLogReducer,
  EMSPCommercialSessionManagement: EMSPCommercialSessionReducer,
  ocpiConnections: OcpiConnectionsReducer,
  ocpiVersions: OcpiVersionsReducer,
  cpoLocations: CPOLocationsReducer,
  cpoTariffs: CPOTariffsReducer,
  cpoSessions: CPOSessionsReducer,
  cpoCdrs: CPOCdrsReducer,
  cpoTokens: CPOTokensReducer,
  cpoCommands: CPOCommandsReducer,
  cpoConnectionLog: CPOConnectionLogReducer,
  emspTokens: EMSPTokensReducer,
  emspCommands: EMSPCommandsReducer,
  emspLocations: EMSPLocationsReducer,
  emspTariffs: EMSPTariffsReducer,
  emspSessions: EMSPSessionsReducer,
  emspCdrs: EMSPCdrsReducer,
  emspConnectionLog: EMSPConnectionLogReducer,
  Invoice: InvoiceReducer,
});

/**
 * Root reducer with reset store functionality
 * @param state - Current state
 * @param action - Action to dispatch
 * @returns Root reducer
 */
const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: AnyAction) => {
  if (action.type === 'RESET_STORE') {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
});

// RootState and AppDispatch types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
